import DateLabel from "components/date-label.component";
import React, { useEffect, useState } from "react";
import { getLatestJobs } from "services/employer.service";
import { Job } from "services/types";

function LatestJobPage() {

  const [latestJobs, setLatestJobs] = useState<Job[]>([])

  useEffect(() => {
    const loadLatestJobs = async () => {
      try {
        const response = await getLatestJobs(0);
        setLatestJobs(response.data);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    };

    loadLatestJobs();
  }, []);

  return (
    <React.Fragment>
      <section className="jobs section">
        <div className="container" data-aos="fade-up">

          <div className="section-header text-center mb-4">
            <h2>Latest Job Openings</h2>
            <p>Explore opportunities that match your skills and experience</p>
          </div>

          <div className="row g-4 justify-content-center">
            {latestJobs.map((job) => (
              <div className="col-lg-4 col-md-6" key={job.id}>
                <div className="job-card">
                  <div className="job-header">
                    <i className="bi bi-gear-wide-connected"></i>
                    <h4>{job.post.name}</h4>
                  </div>
                  <p><i className="bi bi-geo-alt"></i> {job.remittances.map(remit => remit.place_of_posting.name).join(',')}</p>
                  <p><i className="bi bi-briefcase"></i> Experience: {job.exp} year(s)</p>
                  <p><i className="bi bi-calendar"></i> Posted: <DateLabel created_at={job.created_at} /></p>
                  <button className="btn btn-indigo">Apply Now</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}

export default LatestJobPage;
